import { Extensions, FieldImage, defineBlocksWithJsonArray, type Block } from 'blockly/core';

const SINGLE_QUOTE_LEFT_URI =
  'data:image/svg+xml,' +
  encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">' +
      '<text x="1" y="10" font-family="Georgia,Times,serif" font-size="11" font-weight="700" fill="#FFFFFF">&#8216;</text>' +
      '</svg>',
  );

const SINGLE_QUOTE_RIGHT_URI =
  'data:image/svg+xml,' +
  encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">' +
      '<text x="2" y="10" font-family="Georgia,Times,serif" font-size="11" font-weight="700" fill="#FFFFFF">&#8217;</text>' +
      '</svg>',
  );

function normalizeSingleCharacter(value: string | null): string {
  if (!value) {
    return 'A';
  }

  const trimmed = value.trim();
  if (!trimmed) {
    return 'A';
  }

  return trimmed.slice(0, 1);
}

function createQuoteField(isLeft: boolean, rtl: boolean): FieldImage {
  const showLeftQuote = rtl ? !isLeft : isLeft;
  return new FieldImage(
    showLeftQuote ? SINGLE_QUOTE_LEFT_URI : SINGLE_QUOTE_RIGHT_URI,
    12,
    12,
    showLeftQuote ? '\u2018' : '\u2019',
  );
}

Extensions.register('text_char_quotes', function (this: Block) {
  for (const input of this.inputList) {
    for (let index = 0; index < input.fieldRow.length; index++) {
      const field = input.fieldRow[index];
      if (field?.name !== 'CHAR') {
        continue;
      }

      input.insertFieldAt(index, createQuoteField(true, this.RTL));
      input.insertFieldAt(index + 2, createQuoteField(false, this.RTL));
      return;
    }
  }
});

Extensions.register('text_char_field_extension', function (this: Block) {
  const field = this.getField('CHAR');
  if (!field) {
    return;
  }

  field.setValidator((newValue: string | null) => normalizeSingleCharacter(newValue));

  if ('addClass' in this && typeof this.addClass === 'function') {
    this.addClass('skyrover-text-char-block');
  }
});

const textBlockDefinitions = [
  {
    type: 'text_char',
    message0: '%1',
    args0: [
      {
        type: 'field_input',
        name: 'CHAR',
        text: 'A',
        spellcheck: false,
      },
    ],
    output: 'char',
    style: 'text_blocks',
    tooltip: 'A single character for serial send/receive and comparisons.',
    helpUrl: '',
    extensions: ['text_char_quotes', 'text_char_field_extension', 'parent_tooltip_when_inline'],
  },
];

export function registerTextBlocks(): void {
  defineBlocksWithJsonArray(textBlockDefinitions);
}
